import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';

import clientRoutes from 'views';

import { PrivateRoute } from 'components/PrivateRoute';
import { IRootStore } from 'store/Root.reducer';
import { PAGES } from 'utils/link';

const RoutesComponent: FC = () => {
  const state = useSelector((state: IRootStore) => state);
  const { isAuthenticated, user } = state.auth;

  return (
    <Routes>
      {clientRoutes.map(
        ({
          path,
          element,
          Layout,
          showBackButton,
          onBackClick,
          isPrivate,
          isPublicOnly,
          title,
          headerElement,
        }) => {
          const resolvedTitle = typeof title === 'function' ? title(state) : title;

          const routeElement = Layout ? (
            <Layout
              title={resolvedTitle}
              showBackButton={showBackButton}
              onBackClick={onBackClick}
              headerElement={headerElement}
            >
              {element}
            </Layout>
          ) : (
            element
          );

          if (isPublicOnly && isAuthenticated && user) {
            const hasSensors = user.role === 'admin' || (user.meta?.sensors_count ?? 0) > 0;
            const redirectPath =
              user.role === 'admin'
                ? PAGES.ADMIN_USERS
                : hasSensors
                  ? PAGES.DASHBOARD.replace(':id', user.id.toString())
                  : PAGES.WELCOME;

            return (
              <Route key={path} path={path} element={<Navigate to={redirectPath} replace />} />
            );
          }

          return (
            <Route
              key={path}
              path={path}
              element={isPrivate ? <PrivateRoute>{routeElement}</PrivateRoute> : routeElement}
            />
          );
        },
      )}
    </Routes>
  );
};

export default React.memo(RoutesComponent);
